module.exports = __webpack_public_path__ + "static/media/apple_tv_airplay_dark.037f6ce7.svg";